import { AxiosResponse } from "axios";
import { axiosInstance } from "../../../../services/v2/axiosInstance";
import { LifecycleDTO } from "../../../../models/EnrollmentUpdateDTO";

/*
	Cerrar / Fusionar un horario con una decisión por persona (Actualizaciones v2, 2026-10-29).
	PUT schedules/{A}/_merge {targetId, reason, decisions[]} y PUT schedules/{A}/_close {reason, decisions[]}.
	Todo o nada: si una persona no se puede, el servidor responde 422 con `people` (quién y por qué) y no mueve a nadie.
*/

export type Choice = "target" | "other" | "paused" | "no_schedule" | "retired" | "graduated" | "postponed" | "not_started";

export interface Decision { enrollmentId: number; choice: Choice; toScheduleId?: number | null; note?: string; }

export interface PersonProblem { enrollmentId: number | null; studentName: string | null; message: string; }

export interface ForCaja { id: number; enrollmentId: number; studentName: string; typeId: number; typeLabel: string | null; }

export interface DecideResult extends LifecycleDTO {
	/** forCaja: lo que quedó Por Aplicar para Caja (Retiro y No Comenzó siempre; lo que mueve dinero si lo pide Académico). */
	result: { batchId: number; applied: number; pendingForCaja: number; forCaja?: ForCaja[]; statusId: number; statusLabel: string | null };
}

const base = (campusId: number, scheduleId: number) => `/admin/campus/${campusId}/schedules/${scheduleId}`;

export const mergeWithDecisions = (campusId: number, scheduleId: number, targetId: number, reason: string, decisions: Decision[]): Promise<AxiosResponse<DecideResult>> =>
	axiosInstance.put<DecideResult>(`${base(campusId, scheduleId)}/_merge`, { targetId, reason: reason || undefined, decisions });

export const closeWithDecisions = (campusId: number, scheduleId: number, reason: string, decisions: Decision[]): Promise<AxiosResponse<DecideResult>> =>
	axiosInstance.put<DecideResult>(`${base(campusId, scheduleId)}/_close`, { reason, decisions });

/** Lista por persona de un 422 de cierre / fusión (vacía si el error es otro). */
export const problemsOf = (error: any): PersonProblem[] => {
	const people = error?.response?.data?.people;
	return Array.isArray(people) ? people : [];
};
